import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, AlertCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Only show once per session
    if (sessionStorage.getItem('exitIntentShown')) return;
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0) {
        setIsVisible(true);
        sessionStorage.setItem('exitIntentShown', 'true');
      }
    };
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-118">
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-119">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setIsVisible(false)} className="absolute inset-0 bg-slate-dark/60 backdrop-blur-sm" data-id="element-120" />

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} className="relative bg-white rounded-2xl p-6 md:p-8 max-w-md w-full shadow-2xl z-10 border border-gray-100" data-id="element-121">
          <button onClick={() => setIsVisible(false)} className="absolute top-4 right-4 text-slate-light hover:text-slate-dark transition-colors" aria-label="Cerrar" data-id="element-122">
            <X className="w-5 h-5" data-id="element-123" />
          </button>

          <div className="text-center" data-id="element-124">
            <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-125">
              <AlertCircle className="w-8 h-8 text-gold" data-id="element-126" />
            </div>

            <h3 className="text-2xl font-black text-slate-dark mb-3" data-id="element-127">
              Antes de irte...
            </h3>

            <p className="text-slate mb-6" data-id="element-128">
              La información correcta es el primer paso para tomar mejores
              decisiones financieras. No dejes pasar la oportunidad de acceder a
              este material educativo.
            </p>

            <div onClick={() => setIsVisible(false)} data-id="element-129">
              <CTAButton href="#pricing" data-id="element-130">🚀 QUIERO ACCEDER AHORA</CTAButton>
            </div>

            <button onClick={() => setIsVisible(false)} className="mt-4 text-sm text-slate-light hover:text-slate underline" data-id="element-131">
              No gracias, prefiero seguir con dudas
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>;
}